if (!customElements.get('product-floating-bar')) {
  customElements.define(
    'product-floating-bar',
    class ProductFloatingBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.primaryButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.floatingButton = document.getElementById(`ProductAtcCta-${this.sectionId}`);
        this.priceSource = document.getElementById(`price-${this.sectionId}`);
        this.priceTarget = document.getElementById(`price-floating-${this.sectionId}`);

        if (!this.primaryButton || !this.floatingButton) {
          this.remove();
          return;
        }

        this.syncPrice();
        this.bindAtcSync();
        this.bindPriceSync();
        this.bindVisibility();
      }

      disconnectedCallback() {
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      syncPrice() {
        if (!this.priceSource || !this.priceTarget) return;
        this.priceTarget.innerHTML = this.priceSource.innerHTML;
      }

      bindPriceSync() {
        if (!this.priceSource || !this.priceTarget) return;

        this.priceObserver = new MutationObserver(() => this.syncPrice());
        this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.sectionId) return;
            this.syncPrice();
          });
        }
      }

      bindAtcSync() {
        const cta = this.floatingButton;
        const primary = this.primaryButton;
        const ctaSpinner = cta.querySelector('.loading__spinner');
        const primarySpinner = primary.querySelector('.loading__spinner');
        const ctaLabel = cta.querySelector('.product-atc-cta__label');
        const primaryLabel = primary.querySelector('.product-atc-cta__label') || primary.querySelector('span');

        cta.addEventListener('click', () => {
          if (primary.getAttribute('aria-disabled') === 'true' || primary.disabled) return;
          primary.click();
        });

        const syncState = () => {
          cta.disabled = primary.disabled;
          if (primary.getAttribute('aria-disabled') === 'true') {
            cta.setAttribute('aria-disabled', 'true');
          } else {
            cta.removeAttribute('aria-disabled');
          }
          cta.classList.toggle('loading', primary.classList.contains('loading'));
          if (ctaSpinner && primarySpinner) {
            ctaSpinner.classList.toggle('hidden', primarySpinner.classList.contains('hidden'));
          }
        };

        const syncLabel = () => {
          if (ctaLabel && primaryLabel) {
            ctaLabel.textContent = primaryLabel.textContent;
          }
        };

        syncState();
        syncLabel();

        new MutationObserver(syncState).observe(primary, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
        });

        if (primaryLabel) {
          new MutationObserver(syncLabel).observe(primaryLabel, {
            childList: true,
            characterData: true,
            subtree: true,
          });
        }
      }

      bindVisibility() {
        const scrollTarget = this.primaryButton.closest('.item-list-atc') || this.primaryButton;

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            const isVisible = entries[0]?.isIntersecting;
            this.toggleBar(!isVisible);
          },
          { root: null, rootMargin: '0px', threshold: 0 }
        );

        this.visibilityObserver.observe(scrollTarget);
      }

      toggleBar(show) {
        this.classList.toggle('product-floating-bar--visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('product-floating-bar-active', show);
      }
    }
  );
}
